var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiCardActions from '@material-ui/core/CardActions';
/**
 * Kareo wrapped component of the Material-UI CardActions. The prop API has been limited to props defined in CardActionsProps.
 *
 * Material-UI CardActions: [Docs](https://v4.mui.com/components/cards/), [API](https://v4.mui.com/api/card-actions/)
 *
 * @storybook: [Card](http://design.kareoprod.ent/design-system/?path=/story/components-surfaces-card--card-example)
 */
var CardActions = React.forwardRef(function (props, ref) {
    return React.createElement(MuiCardActions, __assign({}, props, { ref: ref }));
});
CardActions.defaultProps = {};
CardActions.displayName = 'KareoCardActions';
export default CardActions;
